import { makeStyles } from '@material-ui/styles'
import Alert from 'core/components/Alert'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import Modal from 'core/elements/modal'
import useUpdateAction from 'core/hooks/useUpdateAction'
import Theme from 'core/themes/model'
import React, { useCallback, useState } from 'react'
import { deleteRepository } from './actions'

export default function DeleteRepositoryDialog({ rows, onClose }) {
  const classes = useStyles()
  const [error, setError] = useState(null)
  const { update, updating } = useUpdateAction(deleteRepository)

  const handleDelete = useCallback(async () => {
    try {
      const results = await Promise.all(rows?.map((repository) => update(repository)))

      const allSuccess = results?.every((result) => result.success)

      if (allSuccess) {
        onClose(true)
      } else {
        setError({
          title: 'Error Deleting Repository',
          message: results
            ?.filter((r) => !r.success)
            ?.map((r) => r.error || 'Unknown error')
            ?.join(', '),
        })
      }
    } catch (err) {
      setError({ title: 'Error Deleting Repository', message: err?.message })
    }
  }, [rows])

  return (
    <Modal
      panel="dialog"
      title={'Delete Repository'}
      onClose={onClose}
      open
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={updating}>
            Cancel
          </Button>
          <Button onClick={handleDelete} loading={updating}>
            Delete
          </Button>
        </>
      }
    >
      {error && <Alert variant="error" title={error?.title} message={error?.message} />}
      <Text variant="body2">Are you sure you want to delete this Repository?</Text>
      <Text variant="body2">
        This action cannot be undone and may prevent access to apps that rely on this Repository.
      </Text>
      <div className={classes.subContainer}>
        <Text variant="body2">Repository URL:</Text>
        <Text variant="caption2">{rows[0]?.url}</Text>
      </div>
    </Modal>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  header: {
    paddingLeft: theme.spacing(1),
  },
  root: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  circleIcon: {
    fontSize: '18px',
    color: '#fff',
  },
  circleError: {
    background: theme.palette.graphRed[100],
    color: theme.palette.graphRed[500],
  },
  subContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
}))
